module.exports = __webpack_public_path__ + "img/logo.1f900c94.png";